import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import { Index, Results, NoResults } from 'vue-instantsearch'
import TestDirective from './directives/test'

Vue.config.productionTip = false

Vue.use(VueClipboard)
Vue.component('ais-index', Index)
Vue.component('ais-results', Results)
Vue.component('ais-no-results', NoResults)

Vue.directive('test', TestDirective)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
